export default __webpack_public_path__ + "static/nexgen-overview-8284e1a35fb6e7c87f876a0ad2f4b730.webp";